import Vue from 'vue';

export const projectDetailsService = {
  async fetchProject(referenceNumber) {
    return Vue.axios.get(`/projects/${referenceNumber}`).then(response => response.data);
  },

  async fetchProjectAttachments(referenceNumber) {
    return Vue.axios
      .get(`/projects/${referenceNumber}/attachments`)
      .then(response => response.data);
  },

  async updateProject(projectData) {
    return Vue.axios
      .put(`/projects/${projectData.referenceNumber}`, projectData.updates)
      .then(response => response.data);
  },

  async updateProjectClientContact(projectClientContact) {
    return Vue.axios.put(`/projects/contact-update`, projectClientContact);
  },

  async updateProjectTesContact(projectTesContact) {
    return Vue.axios.put(`/projects/tes-contact-update`, projectTesContact);
  },

  async createEventType(request) {
    return Vue.axios
      .post(`/projects/${request.projectReferenceNumber}/event-types`, request.eventType)
      .then(response => response.data);
  }
};
